export default { sha: 'd09c7806cc97e1a1aedc6258ef08129d7c722bbb', buildNumber: 'undefined' }
